// extracted by mini-css-extract-plugin
module.exports = {"container":"search_filters_categories-module__container--3zMhA"};